<aside class="h-full bg-sidebar flex flex-col transition-all duration-300" [class.w-60]="isExpanded()"
    [class.w-24]="!isExpanded()">
    <div class="self-stretch bg-sidebar-header text-on-sidebar-header shrink-0">
        <ng-content select="immo-sidebar-header" />
    </div>
    <div class="grow flex flex-col gap-5 p-5">
        <button
            class="shrink-0 self-end flex items-center justify-center p-2 rounded-sm bg-sidebar hover:brightness-95 hover:dark:brightness-125 transition-all duration-150"
            matRipple [matTooltipShowDelay]="300" [matTooltipPosition]="'right'"
            [matTooltip]="isExpanded() ? 'Collapse sidebar' : 'Expand sidebar'" icon="sidebar-simple"
            [class.cursor-w-resize]="isExpanded()" [class.cursor-e-resize]="!isExpanded()" (click)="toggle()">
            <mat-icon class="size-5!" [svgIcon]="ICON.sidebarSimple" />
        </button>

        <div class="grow overflow-y-auto overflow-x-visible thin-scrollbar">
            <ng-content select="immo-navigation" />
        </div>

        <!-- App-specific footer actions (assistant, profile/logout) — projected so the
             shared sidebar stays app-agnostic -->
        <ng-content select="immo-sidebar-footer" />

        <immo-theme-picker class="shrink-0" />
        <immo-language-picker class="shrink-0" />
    </div>
</aside>